import { render, staticRenderFns } from "./listar-fale-com-a-gente.vue?vue&type=template&id=45a8baae&"
import script from "./listar-fale-com-a-gente.vue?vue&type=script&lang=ts&"
export * from "./listar-fale-com-a-gente.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45a8baae')) {
      api.createRecord('45a8baae', component.options)
    } else {
      api.reload('45a8baae', component.options)
    }
    module.hot.accept("./listar-fale-com-a-gente.vue?vue&type=template&id=45a8baae&", function () {
      api.rerender('45a8baae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fale-com-a-gente/listar-fale-com-a-gente.vue"
export default component.exports